import { useAppStore } from "../store/appStore";
import type { TranslationDictionary } from "../utils/i18n";
import { translations } from "../utils/i18n";

/**
 * 現在の UI 言語に対応する翻訳辞書を返すフック。
 * `const t = useTranslation();` として使用する。
 */
export const useTranslation = (): TranslationDictionary => {
	const uiLanguage = useAppStore((state) => state.uiLanguage);
	return translations[uiLanguage];
};
